/**
 * UlToSelect JS controller. Used for <ul>s which we want to convert to <select>s when js
 * is enabled.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class UlToSelect
 */
class UlToSelect {

    /**
     * Class constructor is for binding class properties.
     */
    constructor() {

    }

    /**
     * This functions is run after all script classes have been instantiated.
     * Use this if you need to access some other script instances before the document ready event.
     */
    init() {
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {

        // Find the <ul> -tags which are converted to <select> -tags
        this.selectDropdownlinks         = $( '.js-select-dropdownlinks' );
        this.selectDropdownlinksChildren = this.selectDropdownlinks.children();
        this.firstSelectOption           = $( '.js-first-select-option' );
        this.formattedSelectDropdown     = '';
    }

    /**
     * All common events
     * @return {void}
     */
    events() {

        // Use an <option> -tags value as a link, on <select> -tags change. Get the url, then go to it.
        this.formattedSelectDropdown.on( 'change', ( e ) => {
            const selectedUrl = $( e.currentTarget ).val();
            window.location.href =  selectedUrl;
        });
    }

    /**
      * Create <select> / <option> -fields from <ul>:s with js-select-dropdownlinks -class.
      * This is because of when JS is not in use/working, selects with urls as values will
      * work as normal <ul> <li> <a> -links.
    */
    ulToSelect() {

        // Show the first select <option>, which works as a title for the <select>
        this.firstSelectOption.removeClass( 'js-hidden' );

        // Create an empty string for the <options>
        let selectItems = '';

        // Go through each <ul> <li> and make it an <option>, add current one to a string containing
        // all of them
        this.selectDropdownlinksChildren.each( ( index, element )=> {

            // Convert <li>:s to <options>
            // Create the permalink first from <ul> <li> <a>:s href attribute, get the name
            // from its text value
            const listItem = $( element );
            const permalink = listItem.children( 'a' ).attr( 'href' );
            const content = listItem.text();

            // Build the current <option> string with the permalink and the name
            const optionString = '<option value="' + permalink + '">'  + content + '</option>';

            // Add the current <option> string to the main string containing all the <option>s
            selectItems = selectItems + optionString;
        });

        // Transform the <ul> to <select> and replace the <li> content with the <option> -content
        // built in this function
        if ( this.selectDropdownlinks.hasClass( 'childpage-list__select--area-lifts' ) ) {
            this.selectDropdownlinks.replaceWith( $( '<select id="choose-neighborhood" class="js-select-dropdownlinks childpage-list__select childpage-list__select--area-lifts"> ' + selectItems + ' </select>' ) );
        } else {
            this.selectDropdownlinks.replaceWith( $( '<select class="js-select-dropdownlinks childpage-list__select"> ' + selectItems + ' </select>' ) );
        }

        // Update the cached dropdown
        this.formattedSelectDropdown = $( '.js-select-dropdownlinks' );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.ulToSelect();
        this.events();
    }
}

// Export the class reference.
module.exports = UlToSelect;



// WEBPACK FOOTER //
// ./assets/scripts/ultoselect.js